import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2 text-darkGray-1 w-full text-sm"
}
const _hoisted_2 = { class: "flex gap-4 items-center" }
const _hoisted_3 = {
  key: 0,
  class: "p-1 text-white text-xs col-span-full place-self-end"
}
const _hoisted_4 = { class: "flex gap-4 items-center" }
const _hoisted_5 = {
  key: 0,
  class: "p-1 text-white col-span-full place-self-end text-xs"
}
const _hoisted_6 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-2 bg-blue-4 text-white w-full text-sm"
}
const _hoisted_8 = { class: "flex gap-2" }

import { ref, reactive, onMounted } from "vue";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import { computed } from "@vue/reactivity";
import { AgePeriod, RangePeriod, ValidatorPeriod } from "@/models/forms/AgePeriod";
import { DOMNodeTransforms, processSlotOutlet } from "@vue/compiler-dom";
import * as dtos from "@/models/dtos";

export default /*@__PURE__*/_defineComponent({
  __name: 'MinMaxAgeInPeriod',
  props: {
   item:{
    type: Object as () => dtos.DynamicProperty,
    required: true
    },
  index:{
    type: String,
    required: true
  },
  periodKey:{
    type:String,
    required:true
  }
},
  emits: ["removeValidation", "saveValidation", "input"],
  setup(__props, { emit: __emit }) {

const props = __props;
/*

*/
onMounted ( () => {
addValidator();
});

const addValidator = () : dtos.AllowedAgeInPeriodPropertyValidator => {
 var validator = props.item.validators.find( (x) => x.name == "allowedAgeInPeriod");
if (validator)
{

}
else
{
  var period = new dtos.AllowedAgeInPeriod();  
  validator = new dtos.AllowedAgeInPeriodPropertyValidator(period);
  props.item.validators.push(validator);

}
return validator;
};

const isEditing = ref(true);

const messages = {
  required: "Fältet är obligatoriskt",
  startDateIsBeforeEndDate: "Datumet kan inte vara före periodens startdatum",
  endDateIsAfterStartDate: "Datumet kan inte vara efter periodens slutdatum",
  ageIsHigherThanMaxAge: "Åldern kan inte vara lägre än maxåldern",
  ageIsLowerThanMinAge: "Åldern kan inte vara högre än minåldern",
  ageIsPositive: "Åldern kan inte vara negativ",
};

const rules = computed(() => {
  return {
    ageLow: {
      required: helpers.withMessage(messages.required, required),
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsLowerThanMinAge: helpers.withMessage(
        messages.ageIsLowerThanMinAge,
        (value: number) => {
          return value <= props.age.maxAge;
        }
      ),
    },
    ageHigh: {
      required: helpers.withMessage(messages.required, required),
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsHigherThanMaxAge: helpers.withMessage(
        messages.ageIsHigherThanMaxAge,
        (value: number) => {
          return value >= props.age.minAge;
        }
      ),
    },
  };
});
const _age = reactive({
  ageLow: 10,
  ageHigh: 11,
});

const v$ = useValidate(rules, _age);

const validate = () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    return true;
  } else {
    return false;
  }
};

const emit = __emit;

const removeValidation = () => {
  emit("removeValidation", props.index);
};

const saveValidation = () => {
  if (!validate()) {
    return;
  }
  isEditing.value = false;
  //emit("saveValidation", props.index, props.age.iageLow, period.ageHigh);
};

return (_ctx: any,_cache: any) => {
  return (isEditing.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Lägsta ålder vid periodens start ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["appearance-none border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-1 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500", { 'border-2 border-red-2': _unref(v$).ageLow.$error }]),
            placeholder: "Ange ålder",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addValidator().data.minAge) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', __props.item.data)))
          }, null, 34), [
            [_vModelText, addValidator().data.minAge]
          ]),
          (_unref(v$).ageLow.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(v$).ageLow.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "col-span-2 mb-1 flex items-center gap-2" }, " Högsta ålder vid periodens slut ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["appearance-none border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-1 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500", { 'border-2 border-red-2': _unref(v$).ageHigh.$error }]),
            placeholder: "Ange ålder",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addValidator().data.maxAge) = $event)),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('input', addValidator().data)))
          }, null, 34), [
            [_vModelText, addValidator().data.maxAge]
          ]),
          (_unref(v$).ageHigh.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(v$).ageHigh.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: saveValidation,
                class: "text-blue-2 hover:text-blue-1 text-left text-sm py-1 px-4 bg-white rounded-lg w-fit"
              }, " Spara villkor "),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = () => removeValidation()),
                class: "text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
              }, " Ta bort villkor ")
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("p", null, [
          _cache[9] || (_cache[9] = _createElementVNode("strong", { class: "leading-relaxed tracking-wide" }, "Följande villkor är aktivt: ", -1)),
          _createTextVNode("Minst " + _toDisplayString(__props.item.data.minAge) + " år vid periodens start och max " + _toDisplayString(__props.item.data.maxAge) + " år vid periodens slut. ", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (isEditing.value = !isEditing.value)),
            class: "text-blue-2 hover:text-blue-1 text-left text-sm py-1 px-4 bg-white rounded-lg w-fit"
          }, " Redigera villkor "),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = () => removeValidation(0)),
            class: "text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("span", null, "Ta bort villkor", -1),
            _createElementVNode("i", { class: "fas fa-close" }, null, -1)
          ]))])
        ])
      ]))
}
}

})